{
  "hubspot": {
    "lifecycleStage": {
      "subscriber": "Abonnent",
      "lead": "Lead",
      "marketingQualifiedLead": "Marketing-qualifizierter Lead",
      "salesQualifiedLead": "Sales-qualifizierter Lead",
      "opportunity": "Opportunity",
      "customer": "Kunde",
      "leadForLater": "Lead für später",
      "partnerLead": "Partner-Lead"
    },
    "leadStatus": {
      "new": "Neu",
      "open": "Offen",
      "inProgress": "In Bearbeitung",
      "openDeal": "Offener Deal",
      "attemptedToContact": "Kontaktversuch",
      "connected": "Verbunden",
      "badTiming": "Ungünstiger Zeitpunkt",
      "meeting": "Termin vereinbart",
      "qualified": "Qualifiziert",
      "unqualified": "Nicht qualifiziert",
      "firstEmail": "Erste E-Mail versendet",
      "firstEmailFollowUp1": "Erste E-Mail | 1. Follow-up",
      "firstEmailFollowUp2": "Erste E-Mail | 2. Follow-up",
      "appointmentScheduled": "Termin vereinbart",
      "notSuitable": "Nicht passend",
      "noConcretization": "Keine Konkretisierung"
    },
    "relationship": {
      "b2bLicense": "B2B-Lizenz (für Endkunden)",
      "partnerLicenseWithoutSeats": "Partner-Lizenz (ohne Seats)",
      "partnerLicenseWithSeats": "Partner-Lizenz (mit Seats)",
      "internationalPartnerLicenseWithSeat": "Internationale Partner-Lizenz (mit Seat)",
      "internationalPartnerLicenseWithoutSeat": "Internationale Partner-Lizenz (ohne Seat)",
      "internationalB2bLicenseEndUser": "Internationale B2B-Lizenz (Endkunde)",
      "externalWorkforceProductDevelopment": "Externe Workforce zur Produktentwicklung",
      "communityCatalyst": "Community Catalyst",
      "technicalIntegrationPartner": "Technischer Integrationspartner"
    }
  }
}
